export default "__VITE_ASSET__DqQBvCH9__"